import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "mb-12"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo",
    src: "media/logos/logo_dip_v.png",
    class: "h-150px"
  })
], -1)
const _hoisted_3 = { class: "d-flex flex-center flex-column-auto p-5" }
const _hoisted_4 = { class: "d-flex flex-center fw-bold fs-6" }
const _hoisted_5 = { class: "kt-login__account" }
const _hoisted_6 = { class: "kt-login__account-msg" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  target: "_blank"
}, " ลิขสิทธิ์ของกรมส่งเสริมอุตสาหกรรม กระทรวงอุตสาหกรรม ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: "d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed",
    style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.getIllustrationsPath('14.png') + ')' })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            _createTextVNode(_toDisplayString(new Date().getFullYear()) + "  ©  ", 1),
            _hoisted_7
          ])
        ])
      ])
    ])
  ], 4))
}